// Denne funksjonen setter fokus på toppen av Refero innholdet, dersom visse kriterier er oppfylt

export const handleFocus = (refElement: HTMLElement, isStepView: boolean, isMicrowebStep: boolean, stepIndex: number | undefined): void => {
  const shouldFocusInStepView = isStepView && !!stepIndex && stepIndex > 0;
  const shouldFocus = isMicrowebStep || shouldFocusInStepView;
  if (shouldFocus) {
    const heading = refElement.querySelector<HTMLElement>('h1, h2, h3, h4, h5, h6');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    } else {
      refElement.setAttribute('tabindex', '-1');
      refElement.focus();
    }
  }
};
